export default __webpack_public_path__ + "static/media/misc-fireplaceA-480w.7d1f64b3.webp";